/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-11-14 15:50:47
 * @LastEditors: WangYuhan
 */
import Layout from '@/layout';

const capacityRouter = {
  path: `/capacity`,
  component: Layout,
  redirect: `/capacity/driver`,
  alwaysShow: true, // will always show the root menu
  name: 'Capacity',
  meta: {
    id: 7,
    title: '运力管理',
    icon: 'yzs_yunliguanli',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
  },
  children: [
    {
      path: 'driver',
      component: () => import('@/views/capacity/drivers/index'),
      name: 'driver',
      meta: {
        id: 71,
        title: '司机',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'vehicle',
      component: () => import('@/views/capacity/vehicles/index'),
      name: 'vehicle',
      meta: {
        id: 72,
        title: '车辆',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'convoy',
      component: () => import('@/views/capacity/convoys/index'),
      name: 'vehicle',
      meta: {
        title: '车队',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'payee',
      component: () => import('@/views/capacity/payee/index'),
      name: 'payee',
      meta: {
        id: 73,
        title: '经纪人',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'hang',
      name: 'hang',
      component: () => import('@/views/capacity/hang/index'),
      meta: {
        id: 74,
        title: '挂靠管理',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
      },
    },
  ],
};
export default capacityRouter;
